(<template>
  <article class="incomplete-profile-modal">
    <div class="incomplete-profile-modal__icon"></div>
    <h3>{{ subtitle }}</h3>
    <p>{{ description }}</p>
    <ul>
      <li v-for="field in missingPart"
          :key="field">
        {{ formatFieldName(field) }}
      </li>
    </ul>
    <div class="incomplete-profile-modal__btns-wrapper">
      <button class="sk-btn sk-btn--white button"
              @click="closeModal">{{ $gettext('Cancel') }}</button>
      <router-link class="sk-btn sk-btn--default button"
                   :to="profileLink">{{ $gettext('Edit profile') }}</router-link>
    </div>
  </article>
</template>)

<script>
  import {mapGetters} from 'vuex';

  export default {
    props: {
      data: {
        type: Object,
        default() {
          return {};
        }
      }
    },
    computed: {
      ...mapGetters('UserInfoStore', ['userUid']),
      missingPart() { return Object.keys(this.data.errors || {}).filter((k) => k !== 'global'); },
      subtitle() { return this.$gettext('Profile is not compeleted'); },
      description() { return this.$gettext('You need to complete your profile in order to request the Purpose Letter. Following fields are missing:'); },
      profileLink() { return this.$makeRoute({name: 'ServerProfileEdit', params: {id: this.userUid}}); },
    },
    watch: {
      $route() {
        this.closeModal();
      }
    },
    methods: {
      closeModal() {
        this.$store.dispatch('ModalStore/closeModal');
      },
      formatFieldName(field) {
        const map = {
          name: this.$gettext('First name and last name'),
          address: this.$gettext('Address'),
          dateOfBirth: this.$gettext('Date of birth'),
          identityVerification: this.$gettext('Identity verification (Bank ID)')
        };
        return map[field];
      }
    }
  };
</script>

<style scoped>
  .incomplete-profile-modal {
    display: block;
    width: 100%;
    padding: 0 32px 32px;
    color: #333;
  }

  .incomplete-profile-modal__icon {
    width: 48px;
    height: 48px;
    margin-bottom: 1.5rem;
    background: center no-repeat url(~@assets/imgs/salita/secure/verification_warning_icon.svg);
  }

  h3 {
    margin-bottom: 1rem;
    font-size: 1.25rem;
  }

  ul {
    padding-left: 1.2rem;
  }

  .incomplete-profile-modal__btns-wrapper {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 25px;
  }

  .button {
    display: inline-block;
    width: auto;
    padding: 0 25px;
  }

  .button:last-of-type {
    margin-left: 20px;
  }
</style>
